var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('form-green-cmp',{directives:[{name:"animation",rawName:"v-animation:bottom.delay",arg:"bottom",modifiers:{"delay":true}}],staticClass:"_reviews",attrs:{"form-info":_vm.form,"button":_vm.button,"action":"reviews","check":true}})}
var staticRenderFns = []

export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./src/templates/components/base/forms/form-reviews.vue?vue&type=template&id=64565f0c&
// module id = 1008
// module chunks = 0